var _rect, _path, _circle, _circle2, _circle3, _circle4, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityDataEvaluation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    title: "data-evaluation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 36,
    fill: "white",
    stroke: "#285FCB",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 17L11 11L18 15L24 7",
    stroke: "#285FCB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 1.5,
    fill: "white",
    stroke: "#285FCB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 1.5,
    fill: "white",
    stroke: "#285FCB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15,
    r: 1.5,
    fill: "white",
    stroke: "#285FCB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 7,
    r: 1.5,
    fill: "white",
    stroke: "#285FCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24C7.84322 24 6.72223 24.4011 5.82803 25.1349C4.93383 25.8688 4.32175 26.89 4.09607 28.0245C3.8704 29.1591 4.04509 30.3368 4.59039 31.357C5.13569 32.3772 6.01786 33.1767 7.08658 33.6194C8.1553 34.0621 9.34446 34.1205 10.4514 33.7847C11.5584 33.4489 12.5147 32.7397 13.1573 31.7779C13.8 30.816 14.0893 29.6611 13.9759 28.5099C13.8625 27.3587 13.3535 26.2824 12.5355 25.4645L9 29L9 24Z",
    fill: "#EEF1F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24C20.0111 24 19.0444 24.2932 18.2221 24.8427C17.3999 25.3921 16.759 26.173 16.3806 27.0866C16.0022 28.0002 15.9031 29.0055 16.0961 29.9755C16.289 30.9454 16.7652 31.8363 17.4645 32.5355C18.1637 33.2348 19.0546 33.711 20.0245 33.9039C20.9945 34.0969 21.9998 33.9978 22.9134 33.6194C23.827 33.241 24.6079 32.6001 25.1573 31.7779C25.7068 30.9556 26 29.9889 26 29L21 29L21 24Z",
    fill: "#EEF1F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityDataEvaluation);
export default __webpack_public_path__ + "static/media/activityDataEvaluation.09289c5b.svg";
export { ForwardRef as ReactComponent };